import bigDecimal from 'js-big-decimal';

export const formatNumber = (number) => {
  return number.toString().replace('.', ',');
};

export const formatNumberWithDecimals = (number, { precision } = { precision: 2 }) => {
  const originalNumber = new bigDecimal(number);
  const multiplier = new bigDecimal(Math.pow(10, precision));
  const workingNumber = originalNumber
    .multiply(multiplier)
    .floor()
    .divide(multiplier, 2)
    .getValue()
    .replace(/(\.\d*[1-9])0+$/, '$1')
    .replace(/\.0+$/, '');
  return formatNumber(workingNumber);
};